var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path, _rect18, _path2, _rect19, _path3, _rect20, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 948,
    viewBox: "0 0 174 948",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 312,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 78,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 552,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 792,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 360,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 126,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 600,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 840,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 408,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 174,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 648,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 888,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 456,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    y: 222,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    y: 696,
    width: 45,
    height: 12,
    fill: "#6a4c94"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 936,
    width: 67,
    height: 12,
    fill: "#6a4c94"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 264,
    width: 91,
    height: 12,
    fill: "#6a4c94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.64 261.224C114.8 258.024 115.92 255.56 118 253.832C120.112 252.072 122.88 251.192 126.304 251.192C128.64 251.192 130.64 251.608 132.304 252.44C133.968 253.24 135.216 254.344 136.048 255.752C136.912 257.128 137.344 258.696 137.344 260.456C137.344 262.472 136.816 264.184 135.76 265.592C134.736 266.968 133.504 267.896 132.064 268.376V268.568C133.92 269.144 135.36 270.168 136.384 271.64C137.44 273.112 137.968 275 137.968 277.304C137.968 279.224 137.52 280.936 136.624 282.44C135.76 283.944 134.464 285.128 132.736 285.992C131.04 286.824 128.992 287.24 126.592 287.24C122.976 287.24 120.032 286.328 117.76 284.504C115.488 282.68 114.288 279.992 114.16 276.44H120.688C120.752 278.008 121.28 279.272 122.272 280.232C123.296 281.16 124.688 281.624 126.448 281.624C128.08 281.624 129.328 281.176 130.192 280.28C131.088 279.352 131.536 278.168 131.536 276.728C131.536 274.808 130.928 273.432 129.712 272.6C128.496 271.768 126.608 271.352 124.048 271.352H122.656V265.832H124.048C128.592 265.832 130.864 264.312 130.864 261.272C130.864 259.896 130.448 258.824 129.616 258.056C128.816 257.288 127.648 256.904 126.112 256.904C124.608 256.904 123.44 257.32 122.608 258.152C121.808 258.952 121.344 259.976 121.216 261.224H114.64ZM142.318 269.048C142.318 263.512 143.31 259.176 145.294 256.04C147.31 252.904 150.638 251.336 155.278 251.336C159.918 251.336 163.23 252.904 165.214 256.04C167.23 259.176 168.238 263.512 168.238 269.048C168.238 274.616 167.23 278.984 165.214 282.152C163.23 285.32 159.918 286.904 155.278 286.904C150.638 286.904 147.31 285.32 145.294 282.152C143.31 278.984 142.318 274.616 142.318 269.048ZM161.614 269.048C161.614 266.68 161.454 264.696 161.134 263.096C160.846 261.464 160.238 260.136 159.31 259.112C158.414 258.088 157.07 257.576 155.278 257.576C153.486 257.576 152.126 258.088 151.198 259.112C150.302 260.136 149.694 261.464 149.374 263.096C149.086 264.696 148.942 266.68 148.942 269.048C148.942 271.48 149.086 273.528 149.374 275.192C149.662 276.824 150.27 278.152 151.198 279.176C152.126 280.168 153.486 280.664 155.278 280.664C157.07 280.664 158.43 280.168 159.358 279.176C160.286 278.152 160.894 276.824 161.182 275.192C161.47 273.528 161.614 271.48 161.614 269.048Z",
    fill: "#6a4c94"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 91,
    height: 12,
    fill: "#6a4c94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.256 46.184V40.904L129.952 18.44H137.776V40.328H142V46.184H137.776V53H131.056V46.184H114.256ZM131.488 25.64L121.648 40.328H131.488V25.64ZM145.318 35.048C145.318 29.512 146.31 25.176 148.294 22.04C150.31 18.904 153.638 17.336 158.278 17.336C162.918 17.336 166.23 18.904 168.214 22.04C170.23 25.176 171.238 29.512 171.238 35.048C171.238 40.616 170.23 44.984 168.214 48.152C166.23 51.32 162.918 52.904 158.278 52.904C153.638 52.904 150.31 51.32 148.294 48.152C146.31 44.984 145.318 40.616 145.318 35.048ZM164.614 35.048C164.614 32.68 164.454 30.696 164.134 29.096C163.846 27.464 163.238 26.136 162.31 25.112C161.414 24.088 160.07 23.576 158.278 23.576C156.486 23.576 155.126 24.088 154.198 25.112C153.302 26.136 152.694 27.464 152.374 29.096C152.086 30.696 151.942 32.68 151.942 35.048C151.942 37.48 152.086 39.528 152.374 41.192C152.662 42.824 153.27 44.152 154.198 45.176C155.126 46.168 156.486 46.664 158.278 46.664C160.07 46.664 161.43 46.168 162.358 45.176C163.286 44.152 163.894 42.824 164.182 41.192C164.47 39.528 164.614 37.48 164.614 35.048Z",
    fill: "#6a4c94"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    y: 504,
    width: 91,
    height: 12,
    fill: "#6a4c94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.656 519.416C119.728 516.856 122.176 514.728 124 513.032C125.824 511.304 127.344 509.512 128.56 507.656C129.776 505.8 130.384 503.976 130.384 502.184C130.384 500.552 130 499.272 129.232 498.344C128.464 497.416 127.28 496.952 125.68 496.952C124.08 496.952 122.848 497.496 121.984 498.584C121.12 499.64 120.672 501.096 120.64 502.952H114.112C114.24 499.112 115.376 496.2 117.52 494.216C119.696 492.232 122.448 491.24 125.776 491.24C129.424 491.24 132.224 492.216 134.176 494.168C136.128 496.088 137.104 498.632 137.104 501.8C137.104 504.296 136.432 506.68 135.088 508.952C133.744 511.224 132.208 513.208 130.48 514.904C128.752 516.568 126.496 518.584 123.712 520.952H137.872V526.52H114.16V521.528L116.656 519.416ZM141.147 509.048C141.147 503.512 142.139 499.176 144.123 496.04C146.139 492.904 149.467 491.336 154.107 491.336C158.747 491.336 162.059 492.904 164.043 496.04C166.059 499.176 167.067 503.512 167.067 509.048C167.067 514.616 166.059 518.984 164.043 522.152C162.059 525.32 158.747 526.904 154.107 526.904C149.467 526.904 146.139 525.32 144.123 522.152C142.139 518.984 141.147 514.616 141.147 509.048ZM160.443 509.048C160.443 506.68 160.283 504.696 159.963 503.096C159.675 501.464 159.067 500.136 158.139 499.112C157.243 498.088 155.899 497.576 154.107 497.576C152.315 497.576 150.955 498.088 150.027 499.112C149.131 500.136 148.523 501.464 148.203 503.096C147.915 504.696 147.771 506.68 147.771 509.048C147.771 511.48 147.915 513.528 148.203 515.192C148.491 516.824 149.099 518.152 150.027 519.176C150.955 520.168 152.315 520.664 154.107 520.664C155.899 520.664 157.259 520.168 158.187 519.176C159.115 518.152 159.723 516.824 160.011 515.192C160.299 513.528 160.443 511.48 160.443 509.048Z",
    fill: "#6a4c94"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    y: 744,
    width: 91,
    height: 12,
    fill: "#6a4c94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.728 738.2V732.008H125.296V767H118.384V738.2H113.728ZM130.975 749.048C130.975 743.512 131.967 739.176 133.951 736.04C135.967 732.904 139.295 731.336 143.935 731.336C148.575 731.336 151.887 732.904 153.871 736.04C155.887 739.176 156.895 743.512 156.895 749.048C156.895 754.616 155.887 758.984 153.871 762.152C151.887 765.32 148.575 766.904 143.935 766.904C139.295 766.904 135.967 765.32 133.951 762.152C131.967 758.984 130.975 754.616 130.975 749.048ZM150.271 749.048C150.271 746.68 150.111 744.696 149.791 743.096C149.503 741.464 148.895 740.136 147.967 739.112C147.071 738.088 145.727 737.576 143.935 737.576C142.143 737.576 140.783 738.088 139.855 739.112C138.959 740.136 138.351 741.464 138.031 743.096C137.743 744.696 137.599 746.68 137.599 749.048C137.599 751.48 137.743 753.528 138.031 755.192C138.319 756.824 138.927 758.152 139.855 759.176C140.783 760.168 142.143 760.664 143.935 760.664C145.727 760.664 147.087 760.168 148.015 759.176C148.943 758.152 149.551 756.824 149.839 755.192C150.127 753.528 150.271 751.48 150.271 749.048Z",
    fill: "#6a4c94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldMarks);
export default __webpack_public_path__ + "static/media/field-marks.986a11030ae7dd48f71e2d37d925fdd3.svg";
export { ForwardRef as ReactComponent };